import { auth, ccs, loading, tickets, toast } from "../types";
import lambdas from "../lambdas/apis"
import api from "../apis"
import { generateIndependentTicketform } from "../utils/form";
import { put, call, all, takeEvery, delay } from "redux-saga/effects";

export function* resetTicketsStore(action) {
    yield put({ type: tickets.RESET_TICKETS_STORE_SUCCESS })
}

export function* createIndependentTickets(action) {
    const { data, existing, addNew, formName, navigate, file, setgtag } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } })
        const form = yield call(generateIndependentTicketform, { ...data }, existing, addNew)
        if (form) {
            const response = yield call(lambdas.tickets.createIndependentTickets, {}, {}, {}, form);
            if (response.data.code === 201) {
                if (response.data.data?.duplicate_sites && data.location_data?.length === response.data.data?.duplicate_sites?.length) {
                    yield put({ type: toast.SEND_TOAST, payload: { status: "danger", message: `Duplicate Sites` } })
                } else {
                    const ticketId = response.data.data.id
                    yield put({ type: toast.SEND_TOAST, payload: { status: "success", message: `Ticket Created Successfully!!!` } })
                    yield put({ type: tickets.VIEW_TICKET_REQUEST, payload: { ticketId: ticketId } })
                }
                if (addNew) {
                    if (response.data.data?.duplicate_sites && response.data.data?.duplicate_sites?.length > 0) {
                    } else {
                        yield all([
                            yield put({ type: tickets.CREATE_INDEPENDENT_TICKETS_SUCCESS, payload: response.data.data }),
                            yield put({ type: tickets.VIEW_TICKET_FAILURE })
                        ])
                        setgtag && setgtag();
                        navigate("/getengineer")
                    }
                } else {
                    yield all([
                        yield put({ type: tickets.CREATE_INDEPENDENT_TICKETS_SUCCESS, payload: response.data.data }),
                        yield put({ type: tickets.VIEW_TICKET_FAILURE })
                    ])
                    setgtag && setgtag();
                    navigate("/getengineer")
                }
                if (!Array.isArray(response.data.data) && response.data.data.id &&
                    data && data.location_data.length === 1) {
                        
                    let captions = {}
                    yield delay(1000);
                    yield* data.location_data.map((ticket, index) => {
                        if (file && file.length > 0) {
                            for( let i = 0; i < file?.length ; i++){
                                captions[file[i].name] = file[i].name
                            }
                            return put({ type: ccs.CCS_UPLOAD_FILES_REQUEST, payload: { conversationId: response.data.data.id, files: file, captions, useConversationId: true, bot: true, description: true } })
                        }
                    })
                }
            } else if (response.data.code === 500 && response.data.data.message.length > 1) {
                yield put({ type: toast.SEND_TOAST, payload: { status: "danger", message: response.data.data.message } })
            }
            else {
                yield put({ type: tickets.CREATE_INDEPENDENT_TICKETS_FAILURE, payload: { message: 'Oops Something went wrong' } })
            }
        }
    } catch (error) {
        yield put({ type: tickets.CREATE_INDEPENDENT_TICKETS_FAILURE, payload: error })
    }
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } })
}

export function* getTicketsList(action) {
    try {
        const { activeTab, projectId, customerId, endUserId, siteId,
            limit = 10, page = 1, count = false, type = 0, next = true, offset = 0, navigate } = action.payload
        yield put({ type: loading.TICKETS_TABLE_LOADING, payload: true })
        let queryParams = { count, type, next, offset }
        if (limit && page) {
            queryParams.limit = limit
            queryParams.page = page
        }
        if (!['', 'all', undefined, null].includes(customerId) && !isNaN(customerId)) queryParams.customerId = customerId
        if (!['', 'all', undefined, null].includes(projectId) && !isNaN(projectId)) queryParams.projectId = projectId
        if (!['', 'all', undefined, null].includes(endUserId) && !isNaN(endUserId)) queryParams.endUserId = endUserId
        if (!['', 'all', undefined, null].includes(siteId) && !isNaN(siteId)) queryParams.siteId = siteId
        if (!['', undefined, null].includes(activeTab)) queryParams.tab = activeTab
        let displayView = `TICKET_VIEW`
        queryParams.view = displayView
        const lastScannedIndex = 0
        queryParams.lastScannedIndex = lastScannedIndex
        const sortBy = "created_at";
        queryParams.sortBy = sortBy
        let response = yield call(lambdas.tickets.getTickets, {}, {}, queryParams)

        if (response.data.code === 200) {
            if (count) yield put({ type: tickets.TICKETS_COUNT_SUCCESS, payload: response.data.count })
            if (response.data.count.alltickets > 0 && navigate) {
                navigate("/ticket")
            } else if (navigate) {
                navigate("/service")
            }
            if (response.data.lastScannedIndex) yield put({ type: tickets.UPDATE_TICKETS_LAST_SCANNED_INDEX_SUCCESS, payload: response.data.lastScannedIndex })
            if (limit && page) {
                yield put({ type: tickets.TICKETS_LIST_SUCCESS, payload: response.data.data })
            }
        } else {
            yield put({ type: tickets.TICKETS_LIST_FAILURE, payload: { message: 'Oops Something went wrong' } })
        }
    } catch (error) {
        yield put({ type: tickets.TICKETS_LIST_FAILURE, payload: { message: error } })
    }
    yield put({ type: loading.TICKETS_TABLE_LOADING, payload: false })

    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName: "otpForm", isLoading: false } })
}

export function* viewTicketById(action) {
    const { ticketId, paymentTransaction = false } = action.payload
    const queryParams = {}
    if (!isNaN(ticketId) && parseInt(ticketId) > 0) queryParams.ticket_id = ticketId
    yield put({ type: loading.VIEW_TICKET_LOADING, payload: true })

    try {
        const response = yield call(api.tickets.viewTicket, {}, {}, queryParams)
        if (response.data.code === 200) {
            yield put({ type: tickets.VIEW_TICKET_SUCCESS, payload: response.data.data })
            if (paymentTransaction) {
                yield put({ type: tickets.GET_TICKET_PAYMENTS_REQUEST, payload: { ticketId } })
            }
        } else {
            yield put({ type: tickets.VIEW_TICKET_FAILURE, payload: { message: 'Oops Something went wrong' } })
        }
    } catch (error) {
        yield put({ type: tickets.VIEW_TICKET_FAILURE, payload: { message: error } })
    }
    yield put({ type: loading.VIEW_TICKET_LOADING, payload: false })

}



export default function* ticketsSaga() {
    yield takeEvery(tickets.TICKETS_LIST_REQUEST, getTicketsList)
    yield takeEvery(tickets.RESET_TICKETS_STORE_REQUEST, resetTicketsStore)
    yield takeEvery(tickets.VIEW_TICKET_REQUEST, viewTicketById)
    yield takeEvery(tickets.CREATE_INDEPENDENT_TICKETS_REQUEST, createIndependentTickets)
}